import styled from "styled-components/macro";
import { ModalSlider } from "@gcs/design-system/react";
import { media, zIndexes } from "../../../utils";

export const ModalCloseIcon = styled.button`
  font-size: 36px;
`;

export const ModalCloseButton = styled.button`
  width: 60px;
  height: 60px;
  position: absolute;
  transition: top 300ms ease, left 300ms ease, right 300ms ease;
  cursor: pointer;
  border: 0;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.brandSecondary.gradient};
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadow.level["03"]};
  color: ${({ theme }) => theme.color.neutral["08"]};
  font-size: 12px;
`;

export const ModalHeader = styled.div`
  position: relative;
  padding-top: 28px;
`;

const ModalBox = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.color.neutral["08"]};
  transition: height 300ms ease-in, width 300ms ease-in;
  padding: 0 20px;
  height: 0;

  & > .Card__Body {
    overflow-y: auto;
    height: 100%;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  &.active {
    height: auto;
    max-height: calc(100vh - 50px);
    animation-name: bottomToTop;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 300ms;
  }

  ${media.lg()} {
    padding: 0 60px;
    height: 100vh !important;
    width: 0;
    border-radius: 16px 0px 0px 16px;

    &.active {
      width: initial;
      max-width: 60vw;
      height: 100vh;
      max-height: initial;
      animation-name: rightToLeft;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 300ms;
    }
  }

  ${ModalCloseButton} {
    top: -30px;
    right: 16px;

    ${media.lg()} {
      left: -90px;
      top: 16px;
    }
  }

  @keyframes bottomToTop {
    0% {
      height: 0;
    }
    100% {
      height: auto;
    }
  }

  @keyframes rightToLeft {
    0% {
      width: 0;
    }
    100% {
      width: 60vw;
    }
  }
`;

export const ModalWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  top: 0;
  bottom: 0;
  display: flex;
  flex-wrapper: wrap;
  justify-content: flex-end;
  z-index: ${({ zIndex = zIndexes.modal }) => Math.min(zIndex, zIndexes.modal)};
  align-items: end;
`;
export const ModalResponsive = styled(ModalSlider)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  borderRadius: "8px",
  padding: "40px 16px 0px",

  maxWidth: "100%",
  width: "100%",
  marginRight: "auto",
  marginLeft: "auto",

  [`${theme.breakpoint.md()}`]: {
    maxWidth: "472px",
    padding: "42px 50px",
  },

  div: {
    maxWidth: "100%",
    padding: "0px !important",
  },
  "a, span": {
    color: theme.color.brandPrimary.light,
    textDecorationLine: "underline",
  },
  "> button:first-of-type": {
    borderRadius: "8px",
    width: "50px",
    height: "50px",

    svg: {
      fontSize: "50px",
      color: "white",
    },
  },

  ".header": {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "32px",

    h1: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "150%",
      textAlign: "start",
      color: theme.color.neutral["02"],

      svg: {
        display: "none",
      },

      [`${theme.breakpoint.md()}`]: {
        fontSize: "28px",
        svg: {
          display: "block",
        },
      },
    },

    p: {
      textAlign: "start",
      wordWrap: "break-word",
      fontSize: "14px",
      fontWeight: "400",
      color: theme.color.neutral["02"],
      lineHeight: "24px",

      [`${theme.breakpoint.md()}`]: {
        fontSize: "18px",
      },
    },
  },

  ".divider": {
    display: "block",
    position: "absolute",
    width: "100%",
    height: "1px",
    background: "#D1DBE3",
    left: 0,

    [`${theme.breakpoint.md()}`]: {
      display: "none",
    },
  },

  ".footer": {
    width: "100%",
    marginTop: "auto",

    button: {
      width: "100%",
      flex: 1,
    },
  },
}));

export default ModalBox;
